import React, { useEffect, useState } from "react";
import { Building2, CheckCircle2, AlertOctagon, Wallet, TrendingUp, IndianRupee } from "lucide-react";
import api, { fmtINR } from "@/lib/api";

export default function SuperDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/super-admin/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-6 text-center text-slate-500">Loading...</div>;
  return (
    <div data-testid="super-dashboard">
      <h1 className="text-3xl font-extrabold tracking-tight">Control Center</h1>
      <p className="text-sm text-slate-500">Platform-wide overview · Tenants · Revenue</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-5">
        <Card icon={Building2} tone="primary" label="Total Tenants" value={d.total_tenants} testId="kpi-total-tenants" />
        <Card icon={CheckCircle2} tone="emerald" label="Active" value={d.active_tenants} testId="kpi-active-tenants" />
        <Card icon={AlertOctagon} tone="rose" label="Suspended" value={d.suspended_tenants} testId="kpi-suspended-tenants" />
        <Card icon={Wallet} tone="violet" label="OTP Wallet Pool" value={fmtINR(d.otp_wallet_total)} testId="kpi-otp-wallet" />
        <Card icon={TrendingUp} tone="emerald" label="Total Revenue" value={fmtINR(d.total_revenue)} testId="kpi-revenue" />
        <Card icon={IndianRupee} tone="amber" label="Total Dues" value={fmtINR(d.total_dues)} testId="kpi-dues" />
      </div>

      <div className="mt-8 bg-white border border-slate-100 rounded-2xl p-6 card-shadow">
        <div className="font-extrabold tracking-tight">Quick Actions</div>
        <div className="text-sm text-slate-500 mt-1">Manage tenants and check OTP usage</div>
        <a href="/super-admin/tenants" data-testid="goto-tenants" className="inline-block mt-3 bg-tenant-primary text-white px-4 py-2 rounded-xl font-bold text-sm">Manage Tenants →</a>
      </div>
    </div>
  );
}

const Card = ({ icon: Icon, tone, label, value, testId }) => {
  const t = {
    primary: "bg-blue-50 text-tenant-primary",
    emerald: "bg-emerald-50 text-emerald-600",
    amber: "bg-amber-50 text-amber-600",
    violet: "bg-violet-50 text-violet-600",
    rose: "bg-rose-50 text-rose-600",
  }[tone];
  return (
    <div data-testid={testId} className="bg-white border border-slate-100 rounded-2xl p-5 card-shadow">
      <div className={`w-10 h-10 rounded-xl grid place-items-center ${t}`}><Icon className="w-5 h-5" /></div>
      <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-slate-400 mt-3">{label}</div>
      <div className="text-xl font-extrabold tracking-tight mt-0.5">{value}</div>
    </div>
  );
};
